import { apolloClient } from "@/plugins/vue-apollo.js";

const updateContactUs = async (_variables, searchKey) => {
    // , limit, skip
  let responseFromApi;
  let variables = _variables;
  let search = searchKey
  // debugger
  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/settings/api/mutations/contactUs/update_contact_us.graphql"),
      variables: variables,
      
      update: (store, { data }) => {
        const query = {
          query: require("@/settings/api/queries/contactUs/contact_us_query.graphql"),
          variables: {
            searchKey: search
          },
        };
        let allContactUs = store.readQuery(query);
        // debugger
        const findIndex = allContactUs.getContactUs.contactUs.findIndex(
          (item) => item._id === data.updateContactUs._id
        );
        findIndex !== -1 &&
          allContactUs.getContactUs.contactUs.splice(
            findIndex,
            1,
            data.updateContactUs
          );
        store.writeQuery({
          ...query,
          data: allContactUs,
        });
      },
    })
    .catch((error) => {
      return error;
    });
  return responseFromApi;
};
export { updateContactUs };
